import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { handleLoaderError } from '@@router/handleLoaderError';

import { EditTagSectionModal } from '../../../../-components/SectionModal/TagSectionModal';

export const Route = createFileRoute(
    '/_authenticated/placement/$tenantId/tag/$tagId/sections/$sectionId',
)({
    context: ({ params }) => ({
        sectionQuery: client.placement.section.get.queryOptions({
            params: { id: params.sectionId },
            query: {},
        }),
    }),
    loader: ({ context }) =>
        context.queryClient
            .query({ ...context.sectionQuery, staleTime: 'static' })
            .catch(handleLoaderError),
    component: EditTagSectionModal,
});
